import { useEffect, useState } from 'react';
import { servGetAllBlocoItem } from '../../servicos/bloco_item_formulario';

function SelectBlocoItemFormularioControlled({ id, value, onChange }) {

    const [blocosItemList, setblocosItemList] = useState([])

    useEffect(() => {
        getAllBlocoItem()
    }, []);

    const getAllBlocoItem = async () => {
        try {
            const blocosItemDaApi = await servGetAllBlocoItem()
            setblocosItemList(blocosItemDaApi)
        } catch (erro) {
            console.log(erro);
        }
    }

    return (
        <div>
            {blocosItemList ? (
                <div className="">
                    <select
                        className="form-control-sm w-100"
                        id={id}
                        value={value || ''}
                        onChange={(e) => onChange(e.target.value || null)}
                    >
                        <option value="" >Selecione uma opção</option>
                        {blocosItemList.map((blocoItem) => (
                            <option key={blocoItem.id} value={blocoItem.id}>
                                {blocoItem.id} - {blocoItem.descricao}
                            </option>
                        ))}
                    </select>
                </div>
            ) : (
                <p>Carregando informações dos blocos de perguntas...</p>
            )}
        </div>
    )
}

export default SelectBlocoItemFormularioControlled